import { Button, Checkbox, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useColors } from "../../Context/ColorsContext"
import { CardHeader, List, ListItemText } from '@mui/material';
import { MediaQuerys } from "../../styles/GlobalStyle";


const { mobile, desktop } = MediaQuerys;

export const CustomCardHeader = styled(CardHeader)(({ theme, side }) => {
  const { colors } = useColors();
  return {
    paddingLeft: '.5rem',
    paddingTop: '.3rem',
    paddingBottom: '.3rem',
    backgroundColor: side === "left" ?
      `color-mix(in srgb, ${colors.buttonActionColor} 25%, white)` :
      `color-mix(in srgb, ${colors.navbarColor} 25%, white)`,
    '& .MuiCardHeader-avatar': {
      marginRight: '0px !important',
    },
    '& .MuiCardHeader-content > span': {
      fontSize: '14px',
    },
    '& .MuiCardHeader-content': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    '& .MuiCardHeader-content span:nth-child(2)': {
      fontSize: '12px',
      backgroundColor: side === "left" ?
        `color-mix(in srgb, ${colors.buttonActionColor} 66%, white)` :
        `color-mix(in srgb, ${colors.navbarColor} 66%, white)`,
      padding: '.3rem .5rem',
      color: colors.white,
      borderRadius: '10px',
    },
    [theme.breakpoints.down('md')]: {
      '& .MuiCardHeader-content span': {
        fontSize: '12px',
      },
      '& .MuiCardHeader-content span:nth-child(2)': {
        fontSize: '11px',
      }
    }
  }
})

export const CustomCheckbox = styled(Checkbox)(({header, side}) => {
  const { colors } = useColors();
  return {
    color: header ? '#a0a0a0ff' : '#cececeff',
    '&.Mui-checked': {
      color: side === 'left' ? colors.buttonActionColor : colors.navbarColor
    },
    '&.MuiCheckbox-indeterminate': {
      color: side === 'left' ? colors.buttonActionColor : colors.navbarColor
    },
    [mobile]: {
      '.MuiListItemIcon-root': {
        minWidth: '30px !important',
      }
    }
  }
})

export const SectionBottomInfo = styled('section')(() => ({
  display:'flex',
  justifyContent:'center',
  alignItems:'center',
  width: '100%'
}))

export const Text = styled(Typography)(() => {
  const { colors } = useColors();
  return {
    color: colors.red,
    fontSize: 16,
    fontWeight: 'bold',
    margin: 0,
    padding: 0,
  }
})

export const ContainerCustomButton = styled('div')(() => {
  return {
    [mobile]: {
      '& .MuiButtonBase-root': {
        minWidth: 'auto',
      }
    }
  }
})

export const CustomListItemText = styled(ListItemText)(({ theme }) => {
  return {
    '.MuiTypography-root': { fontSize: '14px' },
    [theme.breakpoints.down('md')]: {
      '.MuiTypography-root': { fontSize: '12px' },
    }
  }
})

export const CustomList = styled(List)(() => {
  const { colors } = useColors();
  return {
    width: 'auto',
    height: '330px',
    backgroundColor: colors.backgroundColor,
    overflow: 'auto',
    [mobile]: {
      width: 'auto',
    }
  }
})

export const ContainerGroupButtons = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1rem',
  }
})

export const TransferButton = styled(Button)(({ side }) => {
  const { colors } = useColors();
  return {
    margin: 0,
    color: side === 'left' ? colors.buttonActionColor : colors.navbarColor,
    width: '40px',
    minWidth: '40px !important',
    borderRadius: '8px',
    height: '40px',
    borderColor: side === 'left' ? colors.buttonActionColor : colors.navbarColor,
    backgroundColor: side === "left" ?
      `color-mix(in srgb, ${colors.buttonActionColor} 5%, white)` :
      `color-mix(in srgb, ${colors.navbarColor} 5%, white)`,
    "&.MuiButton-outlined.Mui-disabled": {
      color: colors.grayGraphic,
    },
    "&:hover": {
      opacity: 0.7,
      borderColor: colors.buttonActionColor,
    },
    '& .MuiSvgIcon-root': {
      color: side === 'left' ? colors.buttonActionColor : colors.navbarColor,
    }
  }
})

export const ContainerContent = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: '1rem 1.5rem',
    [theme.breakpoints.down('sm')]: {
      minWidth: '600px !important',
    }
  }
})

export const ColumnLeft = styled('div')(() => {
  return {
    paddingRight: '1rem',
    width: '47%',
  }
})

export const ColumnCenter = styled('div')(() => {
  return {
    width: '6%'
  }
})

export const ColumnRight = styled('div')(() => {
  return {
    paddingLeft: '1rem',
    width: '47%'
  }
})
